/**
 * Exportações da chamada.
 *
 * O que o auditor leva embora precisa sair da própria tela, sem depender de um
 * pedido a TI — é essa a promessa do painel de trilha.
 */

import type { CallState } from './callEngine'
import { clock } from './format'

function download(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

const csvCell = (value: string) => `"${value.replace(/"/g, '""')}"`

/** BOM na frente para o Excel abrir UTF-8 sem quebrar acento. */
const csvBlob = (csv: string) => new Blob([`﻿${csv}`], { type: 'text/csv;charset=utf-8' })

export function exportAudit(state: CallState, policyVersion: string, format: 'json' | 'csv') {
  if (format === 'json') {
    download(
      new Blob(
        [
          JSON.stringify(
            {
              policy_version: policyVersion,
              duration: clock(state.elapsed),
              entries: state.audit,
              tool_calls: state.toolCalls,
              artifacts: state.artifacts.map((artifact) => ({
                id: artifact.id,
                kind: artifact.kind,
                title: artifact.title,
                status: artifact.status,
              })),
            },
            null,
            2,
          ),
        ],
        { type: 'application/json' },
      ),
      'trilha-auditoria.json',
    )
    return
  }

  const csv = [
    'momento,evento,hash,versao_politica',
    ...state.audit.map((entry) =>
      [entry.at, csvCell(entry.event), entry.hash, entry.policy_version].join(','),
    ),
  ].join('\n')
  download(csvBlob(csv), 'trilha-auditoria.csv')
}

export function exportTranscript(state: CallState, clientName: string) {
  const lines = state.turns.map((turn) => {
    const who = turn.speaker === 'ai' ? 'ALICE (IA)' : clientName.toUpperCase()
    const marks = turn.marks.map((mark) => `\n    [${mark.kind}] ${mark.label}`).join('')
    return `[${turn.at}] ${who}: ${turn.text}${marks}`
  })
  download(
    new Blob([lines.join('\n\n')], { type: 'text/plain;charset=utf-8' }),
    'transcricao.txt',
  )
}
